/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-DocumentCardPreview-iconContainer{background-color:"},{"theme":"themePrimary","defaultValue":"#0078d7"},{"rawString":"}\n"}]);